/* eslint-disable max-len */
import React from 'react';

export function QuickGuide(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64" {...props}>
      <g clipPath="url(#clip0_1481_5460)">
        <mask
          id="mask0_1481_5460"
          style={{ maskType: 'luminance' }}
          width="64"
          height="64"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#fff"
            d="M64 32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32 17.673 0 32-14.327 32-32z"
          ></path>
        </mask>
        <g mask="url(#mask0_1481_5460)">
          <path
            fill="#525266"
            d="M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z"
          ></path>
          <mask
            id="mask1_1481_5460"
            style={{ maskType: 'luminance' }}
            width="29"
            height="38"
            x="18"
            y="13"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" d="M46.5 13H18v38h28.5V13z"></path>
          </mask>
          <g mask="url(#mask1_1481_5460)">
            <mask
              id="mask2_1481_5460"
              style={{ maskType: 'luminance' }}
              width="29"
              height="38"
              x="18"
              y="13"
              maskUnits="userSpaceOnUse"
            >
              <path fill="#fff" d="M46.37 13H18v38h28.37V13z"></path>
            </mask>
            <g mask="url(#mask2_1481_5460)">
              <path
                fill="url(#paint0_linear_1481_5460)"
                d="M18.455 48.31s-.515-3.643 3.502-3.924c4.018-.28 23.624.42 23.624.42s-.824 4.064 0 5.816c-3.777-.035-25.615 0-25.615 0s-1.639-.803-1.511-2.312z"
              ></path>
              <path
                fill="url(#paint1_linear_1481_5460)"
                d="M45.958 50.189H21.236c-.504 0-2.427.128-2.38-2.067.021-1.056.572-1.706 1.138-2.118a3.037 3.037 0 011.799-.568H44.31c2.109 0 1.703-2.87 1.703-2.87l-23.999.603s-3.571 2.156-3.952 4.356a4.02 4.02 0 000 1.408C18.28 50.125 19.302 51 20.49 51h25.468a.404.404 0 00.412-.406.404.404 0 00-.412-.405z"
              ></path>
              <path
                fill="url(#paint2_linear_1481_5460)"
                d="M44.503 13.035H21.471V44.81l23.032.104c.88 0 1.51-.835 1.51-1.731v-28.56c0-.897-.63-1.587-1.51-1.587z"
              ></path>
              <path
                fill="url(#paint3_linear_1481_5460)"
                d="M21.51 13s-3.708.754-3.433 3.67c.275 2.916-.015 30.85-.015 30.85s1.114-2.713 3.449-2.713V13z"
              ></path>
              <path
                fill="url(#paint4_linear_1481_5460)"
                d="M34.541 24.855V38h-3.114V24.855h3.114zm.427-3.83c0 .273-.054.529-.163.768-.109.24-.255.448-.44.628-.175.18-.385.324-.627.435a1.981 1.981 0 01-.779.154 1.95 1.95 0 01-.766-.154 2.133 2.133 0 01-1.042-1.063c-.1-.24-.151-.495-.151-.769 0-.282.05-.546.15-.794.11-.248.252-.461.428-.64.175-.18.38-.321.615-.423a1.82 1.82 0 01.766-.167c.276 0 .536.055.779.167.242.102.452.243.628.422a2.014 2.014 0 01.602 1.435z"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1481_5460"
          x1="27.213"
          x2="30.328"
          y1="50.196"
          y2="41.851"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#484856"></stop>
          <stop offset="1" stopColor="#6E6E8F"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1481_5460"
          x1="32.871"
          x2="32.731"
          y1="50.058"
          y2="42.556"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9A9B9"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1481_5460"
          x1="33.742"
          x2="33.742"
          y1="44.913"
          y2="13.035"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BEBECC"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1481_5460"
          x1="19.87"
          x2="5.993"
          y1="43.666"
          y2="21.724"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9A9B9"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1481_5460"
          x1="33.059"
          x2="33.059"
          y1="12.633"
          y2="43.381"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#353544" stopOpacity="0.91"></stop>
          <stop offset="1" stopColor="#232335" stopOpacity="0.98"></stop>
        </linearGradient>
        <clipPath id="clip0_1481_5460">
          <path fill="#fff" d="M0 0H64V64H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
